import { useParams } from 'react-router-dom';
import DashboardPage from '../../components/DashboardPage';
import useAuth from '../../hooks/use-auth';
import { ROUTES } from '../../routing';
import { useTeamsDashboard } from '../../hooks/use-hydra/teams';

export default function Dashboard() {
  const { trackSlug, companySlug, moduleSlug } =
    useParams<{
      trackSlug: string;
      companySlug: string;
      moduleSlug: string;
    }>();

  const dashboardData = useTeamsDashboard({
    trackSlug: trackSlug ?? '',
    teamSlug: companySlug,
    moduleSlug: moduleSlug ?? '',
  });
  const { user } = useAuth();

  const getActivityUrl = (
    mission: {
      slug: string;
    },
    activity: {
      slug: string;
    }
  ) =>
    ROUTES.TEAMS.ACTIVITY.getPath({
      trackSlug: trackSlug ?? '',
      missionSlug: mission.slug,
      activitySlug: activity.slug,
      teamSlug: companySlug,
    });

  return (
    <DashboardPage
      user={user}
      statsState={dashboardData}
      getActivityUrl={getActivityUrl}
    />
  );
}
